import { defineEffect } from '../../../core/effect';
import { summonPanel } from '../fx/summonPanel';

/**
 * **召喚成功（ステータスのパネル）**（Issue #578 v1。指示書 `../direction/summoned.md`。キービジュアルは無い＝方向は人が決めた）。
 * 組み立ては特殊召喚の成功（`spsummoned.js`）と共有（`../fx/summonPanel.js`）。
 */
export default defineEffect(summonPanel({
  situation: 'summoned',
  role: 'effect',
  label: '召喚成功（ステータスのパネル）',
  color: '#ffd21a',
}), 'summoned_effect.js');
